"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"  // Added ArrowLeft icon
import { Eye, EyeOff } from "lucide-react"  // Added ArrowLeft icon
import { useDispatch, useSelector } from "react-redux"
import { useMediaQuery } from "react-responsive"
import toast from "react-hot-toast"
// import { GoogleLogin } from "@react-oauth/google"
import {
  signupUser,
  loginUser,
  // googleAuth,
  forgotPassword,
  verifyOtp,
  changePassword,
  openOtpModal,
  closeOtpModal,
  verifyOtpforsignup
} from "../../redux/slices/authSlice"
import "./login-signup.css"

import ForgotPassword from "./ForgotPassword"
import OtpVerification from "./OtpVerification"
import ResetPassword from "./ResetPassword"
import CandyWorld from "./CandyWorld"

export default function LoginSignup() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error, token, isOtpModalOpen, otpEmail } = useSelector((state) => state.auth)
  const isDesktop = useMediaQuery({ minWidth: 1024 })
  const isMobile = useMediaQuery({ maxWidth: 768 })  // Added mobile detection
  const [isSignup, setIsSignup] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  // Forgot password states
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false)
  const [otpVerificationLoading, setOtpVerificationLoading] = useState(false)
  const [resetPasswordLoading, setResetPasswordLoading] = useState(false)
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false)
  const [showOtpVerificationModal, setShowOtpVerificationModal] = useState(false)
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false)
  const [forgotEmail, setForgotEmail] = useState("")
  const [otp, setOtp] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false)

  // Form validation errors
  const [formErrors, setFormErrors] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    dateOfBirth: "",
  })

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    dateOfBirth: "",
    gender: "Male", // Default gender
  })

  // Handle back button click
  const handleBackClick = () => {
    navigate('/')
  }

  // Redirect if user is already logged in
  useEffect(() => {
    if (token) {
      navigate("/")
    }
  }, [token, navigate])

  // Show OTP modal if isOtpModalOpen is true
  useEffect(() => {
    if (isOtpModalOpen) {
      setShowOtpVerificationModal(true)
      setForgotEmail(otpEmail)
    }
  }, [isOtpModalOpen, otpEmail])

  useEffect(() => {
    document.body.style.backgroundColor = "#f0f0f0"
    return () => {
      document.body.style.backgroundColor = "#fff"
    }
  }, [])

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const validatePassword = (password) => {
    return password.length >= 8
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({
      ...formData,
      [name]: value,
    })

    // Clear error when user types
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: "",
      })
    }
  }

  const handleGenderChange = (gender) => {
    setFormData({
      ...formData,
      gender,
    })
  }

  // const responseGoogle = (response) => {
  //   if (response.credential) {
  //     dispatch(googleAuth({ tokenId: response.credential }))
  //       .then((res) => {
  //         if (!res.error) {
  //           navigate("/")
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Google login failed:", err)
  //         toast.error("Google login failed. Please try again.")
  //       })
  //   } else {
  //     console.error("Google login failed")
  //     toast.error("Google login failed. Please try again.")
  //   }
  // }

  const validateForm = () => {
    const errors = {}
    let isValid = true

    // Email validation
    if (!formData.email) {
      errors.email = "Email is required"
      isValid = false
    } else if (!validateEmail(formData.email)) {
      errors.email = "Please enter a valid email address"
      isValid = false
    }

    // Password validation
    if (!formData.password) {
      errors.password = "Password is required"
      isValid = false
    } else if (!validatePassword(formData.password)) {
      errors.password = "Password must be at least 8 characters long"
      isValid = false
    }

    // Additional validations for signup
    if (isSignup) {
      if (!formData.name) {
        errors.name = "Name is required"
        isValid = false
      }

      if (formData.password !== formData.confirmPassword) {
        errors.confirmPassword = "Passwords do not match"
        isValid = false
      }

      if (!formData.dateOfBirth) {
        errors.dateOfBirth = "Date of birth is required"
        isValid = false
      }
    }

    setFormErrors(errors)
    return isValid
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!validateForm()) {
      return
    }

    const userData = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      dateOfBirth: formData.dateOfBirth,
      gender: formData.gender,
    }

    if (isSignup) {
      dispatch(signupUser(userData)).then((res) => {
        if (!res.error) {
          // Reset form after successful signup
          // setFormData({
          //   name: "",
          //   email: "",
          //   password: "",
          //   confirmPassword: "",
          //   dateOfBirth: "",
          //   gender: "Male",
          // })

          // Facebook Pixel - Complete Registration
          if (typeof window.fbq === "function") {
            window.fbq("track", "CompleteRegistration", {
              value: 0, // optional: assign value if applicable
              currency: "INR",
              content_name: "Signup",
            });
          }
          // If the API response indicates OTP verification is needed
          if (res.payload && res.payload.requiresOtp) {
            dispatch(openOtpModal(userData.email))
          } else {
            // Navigate after a short delay to allow the user to see the success message
            setTimeout(() => {
              setShowOtpVerificationModal(true)
            }, 1500)
          }
        }
      })
    } else {
      dispatch(loginUser({ email: formData.email, password: formData.password })).then((res) => {
        if (!res.error) {

          // Facebook Pixel - Optional for login, usually CompleteRegistration is for signup
          if (typeof window.fbq === "function") {
            window.fbq("track", "CompleteRegistration", {
              value: 0,
              currency: "INR",
              content_name: "Login",
            });
          }
          // Navigate after a short delay to allow the user to see the success message
          setTimeout(() => {
            navigate("/")
          }, 1500)
        }
      })
    }
  }

  // Forgot password handlers
  const handleForgotPassword = () => {
    setShowForgotPasswordModal(true)
  }

  const validateForgotEmail = () => {
    if (!forgotEmail) {
      toast.error("Please enter your email")
      return false
    }
    if (!validateEmail(forgotEmail)) {
      toast.error("Please enter a valid email address")
      return false
    }
    return true
  }

  const handleSendOtp = (e) => {
    e.preventDefault()

    if (!validateForgotEmail()) {
      return
    }

    setForgotPasswordLoading(true)

    // Call the forgotPassword action from Redux
    dispatch(forgotPassword(forgotEmail))
      .then((res) => {
        if (!res.error) {
          setShowForgotPasswordModal(false)
          setShowOtpVerificationModal(true)
        }
        setForgotPasswordLoading(false)
      })
      .catch((err) => {
        console.error("Failed to send OTP:", err)
        setForgotPasswordLoading(false)
        toast.error("Failed to send OTP. Please try again.")
      })
  }

  const validateOtp = () => {
    if (!otp) {
      toast.error("Please enter the OTP")
      return false
    }

    // Validate OTP format (6 digits)
    if (!/^\d{6}$/.test(otp)) {
      toast.error("Please enter a valid 6-digit OTP")
      return false
    }

    return true
  }

  const handleVerifyOtp = (e) => {
    e.preventDefault()

    if (!validateOtp()) {
      return
    }

    setOtpVerificationLoading(true)

    // Call the verifyOtp action from Redux
    if (!isSignup) {
      dispatch(verifyOtp({ otp, email: forgotEmail }))
        .then((res) => {
          if (!res.error) {
            setShowOtpVerificationModal(false)
            setShowResetPasswordModal(true)
          }
          setOtpVerificationLoading(false)
        })
        .catch((err) => {
          console.error("OTP verification failed:", err)
          setOtpVerificationLoading(false)
          toast.error("OTP verification failed. Please try again.")
        })
    } else {
      dispatch(verifyOtpforsignup({
        otp,
        email: formData.email,
        password: formData.password,
        fullName: formData.name,
        dob: formData.dateOfBirth,
        gender: formData.gender
      }))
        .then((res) => {
          if (!res.error) {
            setShowOtpVerificationModal(false)
            navigate("/")
          }
          setOtpVerificationLoading(false)
        })
        .catch((err) => {
          console.error("OTP verification failed:", err)
          setOtpVerificationLoading(false)
          toast.error("OTP verification failed. Please try again.")
        })
    }
  }

  const validateResetPassword = () => {
    if (!newPassword || !confirmNewPassword) {
      toast.error("Please fill all fields")
      return false
    }

    if (newPassword.length < 8) {
      toast.error("Password must be at least 8 characters long")
      return false
    }

    // Check for at least one number and one special character
    const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])/
    if (!passwordRegex.test(newPassword)) {
      toast.error("Password must contain at least one number and one special character")
      return false
    }

    if (newPassword !== confirmNewPassword) {
      toast.error("Passwords do not match")
      return false
    }

    return true
  }

  // Update the handleResetPassword function to correctly handle the API call
  const handleResetPassword = (e) => {
    e.preventDefault()

    if (!validateResetPassword()) {
      return
    }

    setResetPasswordLoading(true)

    // Call the changePassword action from Redux with the correct payload structure
    dispatch(
      changePassword({
        email: forgotEmail,
        password: newPassword,
      }),
    )
      .then((res) => {
        if (!res.error) {
          setShowResetPasswordModal(false)
          // Clear all states
          setForgotEmail("")
          setOtp("")
          setNewPassword("")
          setConfirmNewPassword("")
          // Navigate to login page after successful password reset
          navigate("/")
        }
        setResetPasswordLoading(false)
      })
      .catch((err) => {
        console.error("Password reset failed:", err)
        setResetPasswordLoading(false)
        toast.error("Password reset failed. Please try again.")
      })
  }

  const closeAllModals = () => {
    setShowForgotPasswordModal(false)
    setShowOtpVerificationModal(false)
    setShowResetPasswordModal(false)
    dispatch(closeOtpModal())
    setForgotEmail("")
    setOtp("")
    setNewPassword("")
    setConfirmNewPassword("")
  }

  // Display error message from Redux state
  useEffect(() => {
    if (error) {
      // Make sure error is a string before displaying
      const errorMessage = typeof error === "string" ? error : "An error occurred. Please try again."
      toast.error(errorMessage)
    }
  }, [error])

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Left Panel - Candy World */}
        {isDesktop && (
          <CandyWorld />
        )}

        {/* Right Panel - Login/Signup Form */}
        <div className="login-panel form-panel">
          {/* Back button for mobile view */}
          {isMobile && (
            <button
              className="back-button"
              onClick={handleBackClick}
              aria-label="Go back"
            >
              <ArrowLeft size={24} />
            </button>
          )}

          <div className="brand-logo">
            <img
              src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1742812127/derby-logo_1_goi8kp.png"
              alt="Derby logo"
              className="logo-image"
            />
          </div>

          <div className="form-header">
            <h2>{isSignup ? "Create an Account" : "Welcome Back"}</h2>
            <p className="form-subtitle">
              {isSignup ? "Please sign up for an account" : "Please login to your account"}
            </p>
          </div>

          <form className="auth-form" onSubmit={handleSubmit}>
            {/* Shared Form Fields */}
            <div className="input-row">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className={formErrors.email ? "error-input" : ""}
                />
                {formErrors.email && <div className="field-error">{formErrors.email}</div>}
              </div>
              {isSignup && (
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className={formErrors.name ? "error-input" : ""}
                  />
                  {formErrors.name && <div className="field-error">{formErrors.name}</div>}
                </div>
              )}
            </div>

            {/* Password Fields */}
            <div className="form-group password-group">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                className={formErrors.password ? "error-input" : ""}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
              {formErrors.password && <div className="field-error">{formErrors.password}</div>}
            </div>

            {/* Forgot Password Link - Only show for login */}
            {!isSignup && (
              <div className="forgot-password">
                <button type="button" className="forgot-password-link" onClick={handleForgotPassword}>
                  Forgot your password?
                </button>
              </div>
            )}

            {isSignup && (
              <div className="form-group password-group">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  className={formErrors.confirmPassword ? "error-input" : ""}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                >
                  {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
                {formErrors.confirmPassword && <div className="field-error">{formErrors.confirmPassword}</div>}
              </div>
            )}

            {/* Other Fields */}
            {isSignup && (
              <div className="input-row">
                <div className="form-group">
                  <input
                    type="date"
                    name="dateOfBirth"
                    placeholder="Date of Birth"
                    value={formData.dateOfBirth}
                    onChange={handleChange}
                    required
                    className={formErrors.dateOfBirth ? "error-input" : ""}
                  />
                  {formErrors.dateOfBirth && <div className="field-error">{formErrors.dateOfBirth}</div>}
                </div>
                <div className="form-group dropdown-container">
                  <div className="custom-dropdown">
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={(e) => handleGenderChange(e.target.value)}
                      required
                    >
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    {/* <ChevronDown className="dropdown-icon" size={16} /> */}
                  </div>
                </div>
              </div>
            )}

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? (
                <span className="loading-spinner">
                  <span className="spinner"></span>
                  {isSignup ? "Signing up..." : "Logging in..."}
                </span>
              ) : isSignup ? (
                "Sign Up"
              ) : (
                "Login"
              )}
            </button>
          </form>

          {/* <div className="divider">
            <span className="divider-line"></span>
            <span className="divider-text">or {isSignup ? "signup" : "login"} with</span>
            <span className="divider-line"></span>
          </div> */}

          {/* <GoogleLogin onSuccess={responseGoogle} onError={(error) => console.error("Google Login Error:", error)} /> */}

          <div className="auth-switch">
            <p>
              {isSignup ? "Already have an account?" : "Don't have an account?"}
              <button type="button" className="switch-button" onClick={() => setIsSignup(!isSignup)}>
                {isSignup ? "Login" : "Signup"}
              </button>
            </p>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgotPasswordModal && (
        <ForgotPassword
          closeAllModals={closeAllModals}
          handleSendOtp={handleSendOtp}
          forgotEmail={forgotEmail}
          setForgotEmail={setForgotEmail}
          forgotPasswordLoading={forgotPasswordLoading}
        />
      )}

      {/* OTP Verification Modal */}
      {showOtpVerificationModal && (
        <OtpVerification
          closeAllModals={closeAllModals}
          handleVerifyOtp={handleVerifyOtp}
          otp={otp}
          otpVerificationLoading={otpVerificationLoading}
          setOtp={setOtp}
        />
      )}

      {/* Reset Password Modal */}
      {showResetPasswordModal && (
        <ResetPassword
          closeAllModals={closeAllModals}
          handleResetPassword={handleResetPassword}
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          confirmNewPassword={confirmNewPassword}
          setConfirmNewPassword={setConfirmNewPassword}
          showNewPassword={showNewPassword}
          setShowNewPassword={setShowNewPassword}
          showConfirmNewPassword={showConfirmNewPassword}
          setShowConfirmNewPassword={setShowConfirmNewPassword}
          resetPasswordLoading={resetPasswordLoading}
        />
      )}

      {/* Add CSS for form error styling and back button */}
      <style jsx>{`
        .back-button {
          position: absolute;
          top: 20px;
          left: 20px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 5px;
          color: #333;
          z-index: 10;
        }
        
        .back-button:hover {
          color: #f83d8e;
        }
        
        /* Ensure proper positioning of other elements when back button is shown */
        .form-panel {
          position: relative;
          padding-top: 15px;
        }
        
        /* Error styling for inputs */
        .error-input {
          border: 1px solid #ff0000 !important;
          border-color: #ff0000 !important;
          color: #ff0000 !important;
          background-color: rgba(255, 0, 0, 0.05) !important;
        }
        
        .error-input::placeholder {
          color: rgba(255, 0, 0, 0.7) !important;
        }
        
        .field-error {
          color: #ff0000;
          font-size: 12px;
          margin-top: 5px;
          font-weight: 500;
        }
        
        /* Make sure error messages don't push layout */
        .form-group {
          position: relative;
          margin-bottom: 20px;
        }
        
        /* Animation for error states */
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
          20%, 40%, 60%, 80% { transform: translateX(5px); }
        }
        
        .error-input:focus {
          animation: shake 0.5s;
          box-shadow: 0 0 5px rgba(255, 0, 0, 0.5) !important;
        }
      `}</style>
    </div>
  )
}